<template>
  <PageTemplate>
    <div class="row">
      <div class="col-md-12">
        <div>
          <v-tabs>
            <v-tab
              name="Un-Used TA"
              :selected="'UN_USED_TA' == getSelectedTab()"
            >
              <v-reports-unused-ta />
            </v-tab>
            <v-tab
              name="Continuing Assessor Competence"
              :selected="'CAC_TA' == getSelectedTab()"
            >
              <v-reports-cac-ta />
            </v-tab>
          </v-tabs>
        </div>
      </div>
    </div>
  </PageTemplate>
</template>
<script>
  import PageTemplate from "@/templates/Page/index.vue";
  import {buildBreadCrumb, columnSort, columnFilter} from "@/common/tableFunctions"
  import ReportsUnusedTA from "./ReportsUnusedTA.vue"
  import ReportsCacTA from "./ReportsCacTA.vue"
  import Tabs from "@/molecules/Tabs";
  import Tab from "@/atoms/Tab";

  export default {
    name: "Reports",
    components: {
      "v-tab": Tab,
      "v-tabs": Tabs,
      "v-reports-unused-ta": ReportsUnusedTA,
      "v-reports-cac-ta": ReportsCacTA,
      PageTemplate
    },
    data: () => ({
    }),
    computed: {
    },
    mounted() {
      this.updateBreadCrumb();

    },
    methods: {
      updateBreadCrumb: function () {
        let breadcrumbs = [];
        breadcrumbs['Reports'] = '';
        this.breadcrumbs = buildBreadCrumb(breadcrumbs);
        this.$store.dispatch('updateBreadCrumbAction', buildBreadCrumb(breadcrumbs));
      },
      getSelectedTab: function() {
        if((''+window.location.href).indexOf('#CAC') !== -1) {
          return 'CAC_TA';
        }
        return 'UN_USED_TA';
      }
    }
  }
</script>

